import { mapActions, mapGetters, mapMutations } from 'vuex';
import cartUpdate from '~/mixins/cart-update';

export default {
    mixins: [cartUpdate],
    data() {
        return {
            userTheme: 'light_theme',
            isAddedToCart: false
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            productsId: 'favorites/getProductsIds',
            compareList: 'compare/getCompareProducts',
            isFarmacie: 'global/getIsFarmacie',
            isNovaPorta: 'global/getIsNovaPorta',
            creditsAvailable: 'global/creditsAvailable',
            isModalShareOpened: 'product/getIsModalShareOpened',
            isAllowNegativeStock: 'global/getIsAllowNegativeStock',
            blackAndWhiteProductCardForPreOrder: 'global/getBlackAndWhiteProductCardForPreOrder'
        }),
        priceNoDiscount() {
            return ((this.product.price * 100) / (100 - this.product.discount)).toFixed();
        },
        isProductStock() {
            return this.isAllowNegativeStock || this.product.stock > 0;
        },
        isFavorite() {
            return this.productsId?.includes(parseFloat(this.product?.productId));
        },
        isCompared() {
            return (
                this.compareList?.findIndex(item => parseFloat(item?.productId) === parseFloat(this.product?.productId)) !== -1
            );
        },
        productTitle() {
            return this.product['title'];
        },
        currentLocaleCode() {
            return this.$i18n.locales.filter(i => i.code === this.$i18n.locale)[0].code;
        }
    },
    methods: {
        ...mapActions('cart', ['addProductToCart']),
        ...mapActions(['buyOneClickProduct', 'firstToKnowClick']),
        ...mapActions(['preorderProductClick']),
        ...mapActions('favorites', ['addProductToFav', 'removeProductToFav']),
        ...mapActions('compare', ['addProductToCompare', 'removeProductToCompare']),
        ...mapMutations('share', ['SET_IS_MODAL_SHARE_OPENED']),
        ...mapMutations({
            setPromoCode: 'cart/SET_PROMO_CODE'
        }),
        async addToCompare(product) {
            if (!this.isCompared) {
                await this.addProductToCompare(product);
            } else {
                await this.removeProductToCompare(product);
            }
        },
        async buyOneClick(product) {
            await this.buyOneClickProduct(product);
        },
        async preorderProduct(product) {
            await this.preorderProductClick(product);
        },
        async addCart(product) {
            if (!this.isAllowNegativeStock && parseFloat(product.stock) <= 0) {
                if (this?.isFirstToKnow) {
                    await this.firstToKnowClick(product);
                } else {
                    await this.preorderProduct(product);
                }
            } else {
                await this.addProductToCart(product);
                this.bcCartUpdatePostMessage();
            }
        },
        setCountExtension(data) {
            const products = this.$store?.getters['cart/getCart']?.products;
            const findedProduct = products?.find(item => Number(item?.product?.productId) === Number(data?.productId));
            const findedProductIndex = products?.findIndex(item => Number(item?.product?.productId) === Number(data?.productId));

            if (findedProduct && findedProductIndex !== -1) {
                const findedProductActiveExtensions = findedProduct?.product?.activeExtensions;

                const findedExtension = findedProductActiveExtensions?.find(
                    item => item?.specification?.id === data?.extensionId
                );
                const findedExtensionIndex = findedProductActiveExtensions?.findIndex(
                    item => item?.specification?.id === data?.extensionId
                );

                if (findedExtension && findedExtensionIndex !== -1) {
                    let newProducts = [...products];
                    let newExtensions = [...findedProduct?.product?.activeExtensions];

                    newExtensions[findedExtensionIndex] = {
                        ...newExtensions[findedExtensionIndex],
                        activeValue: {
                            ...newExtensions[findedExtensionIndex]?.activeValue,
                            activeCount: data?.count
                        }
                    };

                    newProducts[findedProductIndex] = {
                        ...findedProduct,
                        product: {
                            ...findedProduct.product,
                            activeExtensions: data?.count
                                ? newExtensions
                                : newExtensions?.filter(newExt => newExt?.activeValue?.activeCount !== 0)
                        }
                    };

                    this.$store.commit('cart/setProducts', newProducts);
                }
            }
        },
        setCountMinus(data) {
            const products = this.$store?.getters['cart/getCart']?.products;

            const findedProduct = products?.find(item => item?.product?.productId === data?.productId);
            const findedProductIndex = products?.findIndex(item => item?.product?.productId === data?.productId);

            if (findedProduct && findedProductIndex !== -1) {
                const findedProductActiveExtensions = findedProduct?.product?.activeExtensions;

                const newExtensions = findedProductActiveExtensions.map(ext => {
                    if (!ext.allow_quantity_exceed_multiplicity) {
                        if (data.count * ext?.activeValue?.multiplicity < ext?.activeValue?.activeCount) {
                            return {
                                ...ext,
                                activeValue: {
                                    ...ext.activeValue,
                                    activeCount: data.count * ext?.activeValue?.multiplicity
                                }
                            };
                        }
                    }

                    return {
                        ...ext
                    };
                });

                let newProducts = [...products];

                newProducts[findedProductIndex] = {
                    ...findedProduct,
                    product: {
                        ...findedProduct.product,
                        activeExtensions: newExtensions
                    }
                };

                this.$store.commit('cart/setProducts', newProducts);
            }

            this.setCount(data);
        },
        setCount(data) {
            this.setPromoCode(null);
            if (data.count > 99999) {
                data.count = 99999;
            }

            this.$store.dispatch('cart/setCount', data);
            this.bcCartUpdatePostMessage();
        },
        removeProduct(productId) {
            this.setPromoCode(null);
            this.$store.dispatch('cart/removeProduct', productId);
            this.bcCartUpdatePostMessage();
        },
        toggleFavProduct(product) {
            const id = product?.productId;
            if (!this.isFavorite) {
                this.addProductToFav(parseFloat(id));

                const globalSettings = this.$store?.state?.global?.globalSettings;

                const currency = globalSettings?.project_currency?.toUpperCase() || '';

                const sendData = {
                    currency: currency,
                    value: Number(product?.price),
                    items: [
                        {
                            item_id: product?.productId,
                            item_name: product?.title,
                            discount: product?.discount || 0,
                            item_brand: product?.brand?.name || '',
                            item_category: product?.category?.[0]?.subcategoryTitle || '',
                            item_category2: product?.category?.[1]?.subcategoryTitle || '',
                            item_category3: product?.category?.[2]?.subcategoryTitle || '',
                            item_category4: product?.category?.[3]?.subcategoryTitle || '',
                            item_category5: product?.category?.[4]?.subcategoryTitle || '',
                            price: product?.discount ? Number(product?.old_price) : Number(product?.price),
                            quantity: 1
                        }
                    ]
                };

                this.$store.dispatch('google_events/sendItemWishlist', sendData);
            } else {
                this.removeProductToFav(parseFloat(id));
            }
        },
        imagePath(path) {
            return `${this.$config.apiBaseUrl}/${path}`;
        }
    },
    mounted() {
        if (!this.userTheme) {
            if (process.client) {
                this.userTheme = document.documentElement.classList.contains('light-theme') ? 'light_theme' : 'dark_theme';
            }
        }
    }
};
